import { store } from '@/lib/store';
import { providerAtom } from '@/store/provider-atoms';

export const getApiHeaders = async (): Promise<Record<string, string>> => {
  const provider = store.get(providerAtom);
  return await provider.getAuthHeaders();
};
